import { DELIVERY_GUIDE } from '@/api/apiModules'
export default {
  module: DELIVERY_GUIDE,
  params: null,
  toolbar: {
    hasToolbar: false
  },
  fillDetailUrl: `${DELIVERY_GUIDE}/detail`,
  viewType: 'form',
  cb() {},
  view: {
    isSimple: false,
    labelWidth: '120px',
    header: {},
    content: [
      {
        isGroup: true,
        $type: 'group',
        $id: 'base',
        // title: '详情',
        $items: [
          {
            $id: 'docName',
            label: '注意事项'
          },
          {
            $id: 'guideSubType',
            label: '注意事项分类'
          },
          {
            $id: 'guideDesc',
            label: '指导内容'
          },
          {
            $id: 'guidePath',
            label: '指导链接地址'
          }
        ]
      }
    ]
  }
}
